import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCompanies,
  fetchSkills,
  fetchTags,
  fetchOutreachTags,
  fetchTemplateTags,
  fetchTalentPools,
  fetchClientCompanys,
} from './actions';

const initialState = {
  isCompaniesLoading: false,
  companies: [],

  isSkillsLoading: false,
  skills: [],

  isTagsLoading: false,
  tags: [],

  isOutreachTagsLoading: false,
  outreachTags: [],

  isTemplateTagsLoading: false,
  templateTags: [],

  isTalentPoolsLoading: false,
  talentPools: [],

  isClientCompanysLoading: false,
  clientCompanys: [],
};

export const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCompanies.pending]: (state) => {
      state.isCompaniesLoading = true;
    },
    [fetchCompanies.fulfilled]: (state, { payload }) => {
      state.companies = payload?.data?.autocomplete || [];
      state.isCompaniesLoading = false;
    },

    [fetchSkills.pending]: (state) => {
      state.isSkillsLoading = true;
    },
    [fetchSkills.fulfilled]: (state, { payload }) => {
      state.skills = payload?.data?.autocomplete || [];
      state.isSkillsLoading = false;
    },

    [fetchTags.pending]: (state) => {
      state.isTagsLoading = true;
    },
    [fetchTags.fulfilled]: (state, { payload }) => {
      state.tags = payload?.data?.autocomplete || [];
      state.isTagsLoading = false;
    },

    [fetchOutreachTags.pending]: (state) => {
      state.isOutreachTagsLoading = true;
    },
    [fetchOutreachTags.fulfilled]: (state, { payload }) => {
      state.outreachTags = payload?.data?.matches?.map(({ key }) => ({
        key,
        value: key,
      }));
      state.isOutreachTagsLoading = false;
    },

    [fetchTemplateTags.pending]: (state) => {
      state.isOutreachTagsLoading = true;
    },
    [fetchTemplateTags.fulfilled]: (state, { payload }) => {
      state.templateTags = payload?.data?.matches?.map(({ key }) => ({
        key,
        value: key,
      }));
      state.isOutreachTagsLoading = false;
    },

    [fetchTalentPools.pending]: (state) => {
      state.isTalentPoolsLoading = true;
    },
    [fetchTalentPools.fulfilled]: (state, { payload }) => {
      state.talentPools = payload?.data || [];
      state.isTalentPoolsLoading = false;
    },

    [fetchClientCompanys.pending]: (state) => {
      state.isClientCompanysLoading = true;
    },
    [fetchClientCompanys.fulfilled]: (state, { payload }) => {
      state.clientCompanys = payload?.data || [];
      state.isClientCompanysLoading = false;
    },
  },
});
export default filterSlice.reducer;
